import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LyrraOneSetupWizard } from '@/components/lyrraone/LyrraOneSetupWizard';
import { useLyrraOneSetupWizard } from '@/hooks/useLyrraOneSetupWizard';
import { isLyrraOneSetupWizardCompleted } from '@/lib/lyrraone-setup-wizard';
import { useAuthStore } from '@/stores/auth.store';
import { useUIStore } from '@/stores/ui.store';

export function LyrraOneSetupWizardHost() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const user = useAuthStore((s) => s.user);
  const manualOpen = useUIStore((s) => s.lyrraoneSetupWizardManualOpen);
  const sessionKey = useUIStore((s) => s.lyrraoneSetupWizardSessionKey);
  const closeManual = useUIStore((s) => s.closeLyrraOneSetupWizard);
  const { eligible, forceOpen } = useLyrraOneSetupWizard();
  const [autoDismissed, setAutoDismissed] = useState(false);

  if (!eligible || !user) return null;

  const completed = isLyrraOneSetupWizardCompleted(user.preferences);
  const isDashboard = pathname === '/dashboard';
  const autoOpen = !completed && isDashboard && !autoDismissed;
  const open = manualOpen || forceOpen || autoOpen;

  if (!open) return null;

  const firstName = user.firstName?.trim() || t('dashboard.home.defaultName', 'Créateur');
  const remountKey = manualOpen || forceOpen ? `manual-${sessionKey}` : 'auto';

  return (
    <LyrraOneSetupWizard
      key={remountKey}
      firstName={firstName}
      forceOpen={manualOpen || forceOpen}
      onCompleted={() => {
        if (manualOpen) closeManual();
        else setAutoDismissed(true);
      }}
    />
  );
}
